import { render, staticRenderFns } from "./RecommendedMatches.vue?vue&type=template&id=3d26c95e&scoped=true"
import script from "./RecommendedMatches.vue?vue&type=script&lang=js"
export * from "./RecommendedMatches.vue?vue&type=script&lang=js"
import style0 from "./RecommendedMatches.vue?vue&type=style&index=0&id=3d26c95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d26c95e",
  null
  
)

export default component.exports